// Lodash
import _get from 'lodash/get';
import _join from 'lodash/join';
import _compact from 'lodash/compact'; // Readers

import userReader from '../../readers/User';
import dealerEmployeeDetailsReader from '../../readers/DealerEmployeeDetails'; // Utils

import { getDealerUserEmployeeDetails } from '../../utils/userUtils';
export var getUserName = function getUserName(user) {
  var userName = userReader.userName(user);
  if (userName) return userName;
  var displayName = userReader.displayName(user);
  if (displayName) return displayName;
  var userFirstName = userReader.firstName(user) || userReader.fname(user);
  var userLastName = userReader.lastName(user) || userReader.lname(user);
  return _join(_compact([userFirstName, userLastName]), ' ');
};

var getDisplayNumberFromEmployeeDealerMap = function getDisplayNumberFromEmployeeDealerMap(user) {
  var dealerEmployeeDetails = getDealerUserEmployeeDetails(user);
  var employeeDisplayNumber = dealerEmployeeDetailsReader.employeeDisplayNumber(dealerEmployeeDetails);
  return employeeDisplayNumber;
};

var getEmployeeDisplayNumber = function getEmployeeDisplayNumber(user) {
  var employeeDisplayNumber = userReader.employeeDisplayNumber(user);

  if (employeeDisplayNumber) {
    return employeeDisplayNumber;
  }

  return getDisplayNumberFromEmployeeDealerMap(user);
};

export var getUserId = function getUserId(user) {
  var id = userReader.id(user);
  var userId = userReader.userId(user);
  var employeeDisplayNumber = getEmployeeDisplayNumber(user);

  var externalId = _get(user, 'externalSourceInfo[0].externalSourceID');

  return externalId || employeeDisplayNumber || userId || id;
};
export var getUserLabel = function getUserLabel(user) {
  var userName = getUserName(user);
  var userId = getUserId(user);

  if (userName && userId) {
    return "".concat(userId, " - ").concat(userName);
  }

  if (userName) {
    return userName;
  }

  if (userId) {
    return userId;
  }

  return '';
};